import { CREATE_ORDER_URL } from './constants';
import { HTTP_METHOD_POST } from '../../constants/httpMethod';

export const createOrder = async (token, partnerId, phoneNumber, fixedFacialValue) => {
    const urlPhoneNumber = phoneNumber ? phoneNumber.replace('+', '%2B') : null;
    let url = `${CREATE_ORDER_URL}?partnerId=${partnerId}`;
    url = urlPhoneNumber ? url.concat(`&phoneNumber=${urlPhoneNumber}`) : url;
    url = url.concat(`&fixedFacialValue=${fixedFacialValue}`);

    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            method: HTTP_METHOD_POST
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const res = await response.json();
        return res.payload;
    } catch (error) {
        console.error('Error while creating order:', error);
        throw error;
    }
};



// WEBPACK FOOTER //
// ./src/services/ebon/utils.js